import ContentModal from './ContentModal'
import FormModal from './FormModal'

function ModalComponents(props: App.ContentfulWebPageModalComponent) {
  switch (props.contentTypeId) {
    case 'componentContentModal':
      return <ContentModal {...props} />
    case 'componentForm':
      return <FormModal {...props} />
    default:
      return null
  }
}

export default ModalComponents
